import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processHistoricalData = (store, rate) => {
    store.commit(mutations.ADD_OR_UPDATE_HISTORICAL_DATA, rate)
}